namespace TabAurous.Inventory {
    export namespace MaterialRequestItemsService {
        export const baseUrl = 'Purchase/MaterialRequestItems';

        export declare function Create(request: Serenity.SaveRequest<MaterialRequestItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<MaterialRequestItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MaterialRequestItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MaterialRequestItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<MaterialRequestItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/MaterialRequestItems/Create",
            Update = "Purchase/MaterialRequestItems/Update",
            Delete = "Purchase/MaterialRequestItems/Delete",
            Retrieve = "Purchase/MaterialRequestItems/Retrieve",
            List = "Purchase/MaterialRequestItems/List",
            CustomList = "Purchase/MaterialRequestItems/CustomList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList'
        ].forEach(x => {
            (<any>MaterialRequestItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
